import { Product } from "@shared/types/ProductTypes.interface";
import S from "../Specifications/Specifications.module.scss";

export const Specifications = ({ specifications }: Product) => {
    return (
        <ul className={S.specifications}>
            {specifications.map((specification, index) => {
                if (specification.value === "") return;
                if (specification.value === "0") return;

                return (
                    <li key={index}>
                        <p>{specification.label}</p>
                        <p>{specification.value}</p>
                    </li>
                );
            })}
        </ul>
    );
};
